export function safelyDefineCustomElement(customElementDefinition) {
    if (!customElementDefinition.hasOwnProperty('tagName')) {
        throw new TypeError('Passed custom element class definition must include a static "tagName" property');
    }

    if (!customElements.get(customElementDefinition.tagName)) {
        customElements.define(customElementDefinition.tagName, customElementDefinition);
    }
}